export const GOOGLE_MAPS_API_KEY = 'AIzaSyDseZX6cQmFDv1rLXoS_hAnY7kHmbLp-Gs'
